if (!customElements.get('rt-countdown')) {
    class RowanCountdown extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.hidden = true;
        this.querySelector('.rt-countdown-end')?.remove();
        this.querySelector('[role="timer"]')?.removeAttribute('hidden');
        let raw = this.dataset.deadline || '';
        if (!raw && this.dataset.midnight === 'true') raw = (this.dataset.midnightDate || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
        const match = /^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(Z|[+-](?:0\d|1[0-4]):[0-5]\d)$/.exec(raw);
        if (!match) return;
        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (year < 1000 || month < 1 || month > 12 || day < 1 || day > days[month - 1]) return;
        if (/^[+-]14:/.test(match[7]) && !match[7].endsWith(':00')) return;
        this.deadline = Date.parse(raw);
        if (!Number.isFinite(this.deadline)) return;
        if (this.update()) this.timer = setInterval(() => this.update(), 1000);
      }
      update() {
        const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
        if (remaining <= 0) {
          this.stop();
          const mode = this.dataset.endMode || 'hide';
          this.hidden = mode === 'hide';
          if (mode === 'zero') this.querySelectorAll('[data-unit]').forEach((node) => node.textContent = '00');
          if (mode === 'message') {
            this.querySelector('[role="timer"]')?.setAttribute('hidden', '');
            let message = this.querySelector('.rt-countdown-end');
            if (!message) { message = document.createElement('p'); message.className = 'rt-countdown-end'; this.appendChild(message); }
            message.textContent = this.dataset.endMessage || '';
          }
          return false;
        }
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        Object.entries(values).forEach(([unit, value]) => { this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0'); });
        this.hidden = false;
        return true;
      }
      stop() { if (this.timer) clearInterval(this.timer); this.timer = null; }
      disconnectedCallback() { this.stop(); }
    }
    customElements.define('rt-countdown', RowanCountdown);
  }
